// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/gfa-chart-layout.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/gfa-chart-layout/gfa-chart-layout.js';
import g1 from '../lessons/meteorology/gfa-chart-layout/gfa-comments-box.js';
import g2 from '../lessons/meteorology/gfa-chart-layout/gfa-corrections.js';

mount([g0, g1, g2]);
